export const LOADING_START = "LOADING_START";
export const LOADING_FAILURE = "LOADING_FAILURE";
export const LOADING_SUCCESS = "LOADING_SUCCESS";

export const GET_LOGGED_IN_USER = "GET_LOGGED_IN_USER";
export const SET_USERS = "SET_USERS";
export const DELETE_USER = "DELETE_USER";
export const ADD_USER = "ADD_USER";
